<template>
  <div class="login-activate-form">
    <el-form
      ref="form"
      :model="model"
      :rules="rules"
      label-position="top"
      @submit.native.prevent="onSubmit"
    >
      <main>
        <h1>Activa tu cuenta</h1>
        <p>Para activar tu cuenta, por favor introduce tu nueva contraseña con la que deseas entrar a la plataforma.</p>
        <el-form-item
          prop="password"
        >
          <el-input
            placeholder="Contraseña"
            v-model="model.password"
            type="password"
            prefix-icon="icon-lock_outline"
          />
        </el-form-item>
      </main>
      <footer>
        <el-row>
          <el-col :span="24">
            <el-button
              native-type="submit"
              class="el-button--block"
              type="primary"
            >Activar Cuenta
            </el-button>
          </el-col>
        </el-row>
      </footer>
    </el-form>
  </div>
</template>

<script>
import LoginActivateModel from './login-activate.model'
/**
   * 'LoginActivateForm' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'LoginActivateForm',
  data () {
    return {
      model: LoginActivateModel.model(),
      rules: LoginActivateModel.rules,
      invalidCredentials: false
    }
  },
  methods: {
    onSubmit (event) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('valid')
          this.$emit('onSubmit', this.model)
        } else {
          console.error('valid')
          this.$emit('onError')
        }
      })
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss">
    .login-activate-form {

    }
</style>



// WEBPACK FOOTER //
// src/modules/login/login-activate-form.vue